
import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Text,
  VStack,
  useToast,
  IconButton,
  Badge,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
} from '@chakra-ui/react';
import { BellIcon } from '@chakra-ui/icons';
import socket from './sockennotification'; // Adjust the import path as necessary

const Notifications = () => {
  const [userId, setUserId] = useState('');
  const [connected, setConnected] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const toast = useToast();

  useEffect(() => {
    socket.on('connect', () => {
      setConnected(true);
      console.log('Connected to socket:', socket.id);
    });

    socket.on('connect_error', (err) => {
      console.error('Connection error:', err?.message);
    });
socket.on('auctionStarted', (notification) => {
  console.log(notification)
})
    socket.on('notification', (notification) => {
      console.log(notification);
      setNotifications((prevNotifications) => [...prevNotifications, notification]);
      toast({
        title: 'New Notification',
        description: notification.message,
        status: 'info',
        duration: 5000,
        isClosable: true,
      });
    });


        socket.on('auctionsstart', (notification) => {
          console.log(notification);
          setNotifications((prevNotifications) => [...prevNotifications, notification]);
          toast({
            title: 'New Notification',
            description: notification.message,
            status: 'info',
            duration: 5000,
            isClosable: true,
          });
        });

    return () => {
      socket.off('connect');
      socket.off('connect_error');
      socket.off('notification');
    };
  }, [toast,connected,notifications]);

  const handleConnect = () => {
    if (userId) {
      socket.auth = { userId,token:"token" };
      socket.connect();
      socket.emit('joinRoom', { userId });
    }
  };

  return (
    <Box maxW="md" mx="auto" mt="10" p="5" borderWidth="1px" borderRadius="lg">
      <VStack spacing="5">
        <FormControl id="userId">
          <FormLabel>User ID</FormLabel>
          <Input
            type="text"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
          />
        </FormControl>
        <Button onClick={handleConnect} colorScheme="teal" isDisabled={connected}>
          {connected ? 'Connected' : 'Connect to Notifications'}
        </Button>
      </VStack>

      <Popover>
        <PopoverTrigger>
          <IconButton
            icon={<BellIcon />}
            aria-label="Notifications"
            variant="outline"
            mt="5"
          >
            {notifications?.length > 0 && (
              <Badge colorScheme="red" variant="solid" ml="1">
                {notifications.length}
              </Badge>
            )}
          </IconButton>
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader>Notifications</PopoverHeader>
          <PopoverBody>
            {notifications?.length > 0 ? (
              notifications.map((notification, index) => (
                <Text key={index}>{notification.message}</Text>
              ))
            ) : (
              <Text>No notifications</Text>
            )}
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};

export default Notifications;

